export const initPhysicianTeaserSlider = () => {
    document.querySelectorAll('.c-physician-teaser').forEach(teaser => {
        const slider = teaser.querySelector('.slider');
        const slides = teaser.querySelectorAll('.c-physician-card');
        const currentText = teaser.querySelector('.current');
        const maxText = teaser.querySelector('.max');

        if (!slider || !slides || !currentText || !maxText) return;

        // If the "slider" class is set, show the pagination.
        teaser.querySelector('.pagination')?.style?.setProperty('display', 'block');

        currentText.innerHTML = '01';
        maxText.innerHTML = String(slides.length).padStart(2, '0');

        let slideIndex = 0;
        let visibleSlides = [];

        // Create an array of all visible slides and their indexes.
        [...slider.children].forEach((slide, index) => {
            visibleSlides.push({ index: index, slide: slide });
        });

        // Get the slide index by its bounding client rect position in the viewport.
        const setSlideIndex = () => {
            for (const slide of visibleSlides) {
                const rect = slide.slide.getBoundingClientRect();

                // Check if the rect is visible horizontally in the viewport.
                if (rect.left >= 0 && rect.right <= window.innerWidth) {
                    slideIndex = slide.index;
                    return;
                }
            }
        };

        // Update the slide index after one second.
        const updateSlideIndex = () => {
            setTimeout(() => {
                setSlideIndex();
                currentText.innerHTML = String(slideIndex + 1).padStart(2, '0');
            }, 1000);
        };

        let dragging = false;

        slider.addEventListener('dragstart', e => e.preventDefault());

        slider.addEventListener('mousedown', () => {
            dragging = true;
            slider.style.setProperty('scroll-snap-type', 'none');
            slider.style.setProperty('user-select', 'none');
        });

        slider.addEventListener('mouseup', () => {
            dragging = false;
            slider.style.setProperty('scroll-snap-type', null);
            slider.style.setProperty('user-select', null);
        });

        slider.addEventListener('mousemove', e => {
            if (dragging === true) slider.scrollLeft -= e.movementX;
        });

        // Add "touchend" event listener to update the slide index on touch devices.
        document.addEventListener('touchend', updateSlideIndex);

        // Add "scroll" event listener to update the slide index on desktop devices.
        slider.addEventListener('scroll', updateSlideIndex);
    });
};

const mobileMediaMatch = window.matchMedia('(max-width: 974px)');

const handleMediaWidthChange = e => {
    document.querySelectorAll('.c-physician-teaser').forEach(teaser => {
        const wrapper = teaser.querySelector('.wrapper');
        const pagination = teaser.querySelector('.pagination');

        if (!wrapper) return;

        // Always add slider functionality on devices smaller than 975px, e.g. mobile and tablet.
        if (e.matches && wrapper.classList.contains('slider') === false) {
            wrapper.classList.add('slider');
            initPhysicianTeaserSlider();

            // If the wrapper has less than 4 children and
            // the viewport is more than 974px wide it should not be a slider.
        } else if (wrapper.children.length <= 3 && wrapper.classList.contains('slider')) {
            wrapper.classList.remove('slider');
            pagination?.style?.setProperty('display', 'none');
        }
    });
};

mobileMediaMatch.addEventListener('change', handleMediaWidthChange);
handleMediaWidthChange(mobileMediaMatch);
